import { CLEAR_TRANSACTION_ATTACHMENT_RESPONSE } from "../action.js";

export const clearAttachmentResponse = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_TRANSACTION_ATTACHMENT_RESPONSE });
    };
};
